import React, { useEffect, useState, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { getAssetCategoryDistributionApi } from "../../../services/DashboardServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const CategoryChart = () => {
  const navigate =useNavigate()
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    getAssetCategoryDistributionApi()
      .then((res) => {
        setData(res?.data?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const labels = useMemo(() => data.map((item) => item.name), [data]);
  const series = useMemo(() => data.map((item) => item.unit_count), [data]);

  const pieOptions = {
    chart: {
      type: "pie",
      height: 245,
      width: "100%",

      events: {
        dataPointSelection: (event, chartContext, config) => {
          const clickedIndex = config.dataPointIndex;
          const clickedCategory =data[clickedIndex];
          navigate(`/assets/table-view?category_id=${clickedCategory.id}`);
        },
      },
    },
    labels,
    colors: [
      "#66b2ff", // Base soft blue
      "#5aa8f5", // Slightly darker blue
      "#7bc1ff", // Slightly lighter blue
      "#4d9ef0", // Deeper blue
      "#99d1ff", // Very soft light blue
      "#338be6", // Stronger blue
    ],
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const count = opts.w.config.series[opts.seriesIndex];
        return count;
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["#fff"],
      },
    },
    legend: {
      show: false,
      position: "bottom",
      horizontalAlign: "center",
      floating: false,
      fontSize: "12px",
      itemMargin: { horizontal: 10, vertical: 4 },
      markers: { width: 6, height: 6 },
      labels: { colors: "#666" },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} items`,
      },
    },
  };

  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="py-2 px-3 d-flex justify-content-between gap-2 flex-wrap">
        <div className="d-flex">
          <h5 className="ms-1">Top 5 Categories</h5>
        </div>
      </div>
      <div className="px-2">
        {series.length > 0 ? (
          <ReactApexChart
            options={pieOptions}
            series={series}
            type="pie"
            height={245}
          />
        ) : (
          <div className="text-center text-dark py-4">Loading...</div>
        )}
      </div>
    </div>
  );
};

export default CategoryChart;
